export const getUrlParam = (fieldName) => {
  
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  return urlParams.get(fieldName);

};